import React from "react"
import SchedulePage from "../../index.jsx"
import ScheduleHeader from "../../Header.jsx"
import ModuleTitle from "../../../../atoms/SchedulePages/ModuleTitle.jsx"
import { Schedule, ScheduleTable } from "../../Schedule.jsx"

import { PickupLocations, PickupLocation } from "../../Locations.jsx"
import { WaterlooLocations } from "../pickup-locations.js"
import { WaterlooMeta, WaterlooFares } from "../metadata.js"
import { WaterlooData } from "../schedule.js"
import CanadaAmenities from "../Amenities.jsx"
import Seo from "../../../../molecules/Seo/index.jsx"
import ScheduleNavigation from "../../Navigation.jsx"
import { Fares, FaresTable } from "../Fares.jsx"
import { TbCalendarTime } from "react-icons/tb"
import { FaMapMarkerAlt, FaMoneyBill, FaWifi } from "react-icons/fa"

const WaterlooNavigation = () => {
  const items = [
    {
      icon: <TbCalendarTime />,
      title: "Schedule",
      scrollTo: "schedule",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Pickup Locations",
      scrollTo: "pickup-locations",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Dropoff Locations",
      scrollTo: "pickup-locations",
    },
    {
      icon: <FaMoneyBill />,
      title: "Fares",
      scrollTo: "fares",
    },
    {
      icon: <FaWifi />,
      title: "Amenities",
      scrollTo: "amenities",
    },
  ]

  return <ScheduleNavigation items={items} />
}

const WaterlooSchedule = ({ history }) => {
  return (
    <SchedulePage>
      <Seo
        title={WaterlooMeta.seo.title}
        description={WaterlooMeta.seo.description}
        canonicalUrl={"https://landline.com/canada/waterloo"}
      />
      {/* <div className="schedule-search-form">
        <Search history={history} remoteCallSearchComponent={true} />
      </div> */}
      <div className="schedule-page">
        <ScheduleHeader metadata={WaterlooMeta.header} />

        <WaterlooNavigation />

        <ModuleTitle title="Schedule" navigationid="schedule" />
        <Schedule>
          <ScheduleTable schedule={WaterlooData.from} />
          <ScheduleTable schedule={WaterlooData.to} />
        </Schedule>

        <PickupLocations>
          {WaterlooLocations.map(location => {
            return <PickupLocation location={location} />
          })}
        </PickupLocations>

        <ModuleTitle title="Fares" navigationid="fares" />
        <Fares>
          <FaresTable fares={WaterlooFares} />
        </Fares>

        <ModuleTitle title="Amenities" navigationid="amenities" />
        <CanadaAmenities />
      </div>
    </SchedulePage>
  )
}

export default WaterlooSchedule
